import { TThunkAction } from '../../types/redux';
import { setTooltipTarget } from './tooltipTarget';
import { updateMeta } from './meta';
import { setSavedFilters } from './savedFilters';
import { IFilters, TFilterKeys } from '../../types/filters';

export const changeSavedFilters = (newValues: IFilters, filterKey: TFilterKeys): TThunkAction => {
  return async (dispatch, getState) => {
    const {
      filters: { tooltipTarget },
    } = getState();

    /* istanbul ignore next */
    if (tooltipTarget !== filterKey) {
      dispatch(setTooltipTarget(filterKey));
    }

    dispatch(setSavedFilters(newValues));

    dispatch(updateMeta());
  };
};
